import type { Region } from '~~/core/entities/Region';

import { PropertyTypeEnum } from '~/core/entities/CRMEnums';

import { getCleanStaticListingPath } from '../links/cleanStaticListingPath';
import { getRegionMetadata } from './utils';

const regionName = 'Jardim América';

const metaTags = getRegionMetadata(regionName, 'São Paulo', { gender: 'male' });

const region: Region = {
	name: regionName,
	state: 'sp',
	city: 'São Paulo',
	country: 'Brasil',
	path: '/bairros/jardim-america',
	image:
		'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/banner.webp',
	metaTags,
	info: {
		title: '',
		description: ''
	},
	hero: {
		title: regionName,
		description:
			'Aos pés da Oscar Freire, um dos bairros mais cobiçados e exclusivos de São Paulo.',
		backgroundImage:
			'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/banner.webp'
	},
	map: {
		title: `${regionName}: clima tranquilo e alta gastronomia aos pés de um dos principais polos de luxo de São Paulo`,
		content: `Entre a Avenida Brasil e a Rua Estados Unidos, está localizado um dos bairros mais desejados de São Paulo: o Jardim América. Com ruas arborizadas e uma porção de casas de rua, este bairro se tornou um dos mais queridos da capital paulista por sua localização incrível e ótimas opções de lazer.<br/><br/>Tranquilo, o bairro vive com uma energia de interior, perfeito para passear a pé e explorar as ruas arborizadas em um dos pontos mais cobiçados. À noite, basta subir uma das ruas que cruzam a Rua Estados Unidos e aproveitar tudo que a Cerqueira César e a rua Oscar Freire têm a oferecer.<br><br>Aos fins de semana, o Jardim América é perfeito para quem quer aproveitar o silêncio e relaxar, mas sua proximidade com os principais shoppings da cidade o torna perfeito para quem quer viver o melhor dos dois mundos: agito de dia e calmaria à noite. Para quem busca diversão para toda a família ou quer um lugar seguro para deixar os filhos, os clubes que ficam no bairro são ótimas escolhas. A seguir, apresentamos o que torna este bairro um dos mais especiais para se viver.`,
		image:
			'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/map.webp',
		links: [
			{
				label: `Ver imóveis no ${regionName}`,
				url: getCleanStaticListingPath({
					propertyTypes: [],
					regions: [regionName],
					states: ['SP'],
					cities: ['São Paulo']
				})
			}
		]
	},
	content: [
		{
			info: {
				title: `Restaurantes no ${regionName}`,
				content:
					'Quer comer bem sem pegar o carro? Aposte no Le Deaux Magots, próximo ao Clube Athlético Paulistano. A unidade recém inaugurada em São Paulo conquistou os amantes do restaurante parisiense de cara. Um ambiente incrível para aproveitar a dois ou com a família.<br><br>Agora, se seu negócio é uma ótima padaria 24h, a Galeria dos Pães é a pedida perfeita. Pão fresquinho, buffet de café da manhã, chá da tarde e sopas madrugada adentro, a Galeria sempre servirá comidas incríveis a qualquer hora do dia. Ah, lá você também encontra uma ótima seleção de produtos, que torna o local um excelente mercado de bairro.<br><br>Para almoçar com a família aos fins de semana ou para um proveitoso almoço de negócios, A Figueira Rubaiyat é uma ótima escolha. Tradicional em São Paulo, o restaurante serve carnes de excelência e uma das feijoadas mais premiadas da cidade.'
			},
			images: [
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-1.webp',
					credits: 'Anima Visual'
				},
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-2.webp'
				}
			]
		},
		{
			info: {
				title: `Os clubes do ${regionName}`,
				content:
					'Sim, o Jardim América conta com clubes para você deixar as crianças, aproveitar o fim de semana e ainda conhecer moradores do bairro. E não é qualquer clube: são os dois de maior prestígio e exclusividade de São Paulo.<br><br>Na Rua Honduras, o Clube Athletico Paulistano, um dos mais tradicionais da cidade, reúne cerca de 5 mil sócios e conta com diversas atividades esportivas – como basquete, beach tennis, vôlei, tênis, badminton, academia completa e mais – duas bibliotecas, sapateado, ballet, piano e teatro além de 13 restaurantes e bares. Cinco piscinas são destaque: social, infantil, olímpica, semi-olímpica e coberta. Sauna, salões de festa, boates, espaços infantis, cinema e quadras de tênis e poliesportiva também compõem o clube.<br><br>Já a Sociedade Harmonia de Tênis é conhecida por ser uma das mais exclusivas da cidade. Com apenas 4 mil sócios, o clube é focado na prática do tênis e conta com nove quadras de saibro',
				class: 'lg:col-start-2'
			},
			images: [
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-4.webp',
					credits: 'Clube Paulistano',
					class: 'row-start-2'
				},
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-3.webp',
					credits: 'Mario Gogh'
				}
			]
		},
		{
			info: {
				title: `As praças do ${regionName}`,
				content:
					'No Jardim América, são as praças que se destacam. A Praça Adolpho Bloch está localizada na Avenida Brasil, ao lado da Igreja Nossa Senhora do Brasil, e conta com um playground e academia ao ar livre. Por lá, também podemos encontrar obras de arte e exposições ao ar livre, que mudam de tempos em tempos. Aos finais de semana, é possível se deparar com aulas de yoga gratuitas.<br><br>Em uma rua pouco movimentada do bairro, está a deliciosa Praça General San Martin, que teve uma reforma há poucos anos, onde sua área para cães foi restaurada e triplicou de tamanho, sendo um dos lugares favoritos para os donos de pet passearem aos fins de semana. Muito bem cuidada, a praça ainda conta com playground e uma ótima área aberta para treinar com personal trainer.'
			},
			images: [
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-5.webp'
				}
			]
		},
		{
			info: {
				title: `Imóvel icônico no ${regionName}`,
				content:
					'Única no país, o Jardim América abriga uma casa desenhada pelos Irmãos Campana. Já decorada e mobiliada, a construção está pronta para ser chamada de lar. Ampla, conta com living, sala de TV, cozinha americana planejada, três suítes com closet, incluindo uma master com sala, dois banheiros e vista para o jardim e piscina, que são um show à parte. Com paisagismo assinado por Kalil Ferre, a área externa conta com um deck de madeira que contorna a casa, além da piscina no centro,espaço gourmet, academia, sauna e tudo que um clube particular tem direito, além de edícula com 100m², dois quartos, banheiros e ampla sala.<br><br>No coração do Jardim América, a casa assinada por Sig Bergamin e Murilo Lomas tem espírito londrino, com pé direito alto e escadas de madeira. Ela conta com 500m² de área construída, quatro dormitórios e duas suítes, além de quatro vagas de garagem.',
				class: 'lg:col-start-2'
			},
			images: [
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-6.webp',
					credits: 'MO1727'
				},
				{
					url: 'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-america/content-7.webp',
					credits: 'ST003',
					class: 'row-start-2'
				}
			]
		}
	],
	nearRegions: [
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/itaim-bibi/banner.webp',
			name: 'Itaim Bibi',
			href: '/bairros/itaim-bibi'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-paulista/banner.webp',
			name: 'Jardim Paulista',
			href: '/bairros/jardim-paulista'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/vila-nova-conceicao/banner.webp',
			name: 'Vila Nova Conceição',
			href: '/bairros/vila-nova-conceicao'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/pinheiros/banner.webp',
			name: 'Pinheiros',
			href: '/bairros/pinheiros'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/alto-de-pinheiros/banner.webp',
			name: 'Alto de Pinheiros',
			href: '/bairros/alto-de-pinheiros'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-europa/banner.webp',
			name: 'Jardim Europa',
			href: '/bairros/jardim-europa'
		},
		{
			image:
				'https://d37vfq26jjkkpt.cloudfront.net/bairros/jardim-paulistano/banner.webp',
			name: 'Jardim Paulistano',
			href: '/bairros/jardim-paulistano'
		}
	],
	questions: [
		{
			question: `Onde fica o ${regionName}?`,
			answer:
				'O Jardim América está localizado na cidade de São Paulo, na Zona Oeste da cidade, dentro do distrito de Cerqueira César, e é administrado pela Subprefeitura da Sé. O bairro está rodeado por áreas nobres como o Jardim Europa, Jardim Paulista, Higienópolis e Cerqueira César. Suas principais avenidas incluem a Avenida Brasil e a Rua Estados Unidos, que conectam o bairro a outros polos da cidade, proporcionando uma excelente infraestrutura e mobilidade.'
		},
		{
			question: `Como chegar ao ${regionName}?`,
			answer:
				'O Jardim América é facilmente acessível de carro, com principais avenidas como a Avenida Brasil e a Rua Estados Unidos oferecendo boas opções de mobilidade. O bairro também é servido por transporte público, com diversas linhas de ônibus circulando pela região. Embora o bairro não tenha uma estação de metrô dentro de seus limites, as estações Consolação e Paulista estão próximas, facilitando o acesso ao bairro..'
		},
		{
			question: `O que fazer no ${regionName}?`,
			answer:
				'O Jardim América oferece diversas opções de lazer e entretenimento. Durante o dia, a Praça Adolpho Bloch é perfeita para relaxamento, yoga e exposições de arte ao ar livre, enquanto a Praça General San Martin, com sua área extensa para cães, é um local tranquilo, ideal para passeios com pets. O bairro ainda é próximo da Rua Oscar Freire, um renomado centro de compras de luxo, com lojas sofisticadas, cafés e restaurantes de alta gastronomia. À noite, o Jardim América se transforma, tornando-se um polo gastronômico e cultural, com bares e restaurantes que oferecem opções de culinária internacional. Para quem busca opções de lazer mais exclusivas, os clubes locais, como o Clube Athletico Paulistano, disponibilizam uma variedade de atividades esportivas e de entretenimento, incluindo piscinas, teatros e cinema, além de se tornarem um ponto de socialização para as famílias. Já a Sociedade Harmonia de Tênis, conhecida por sua exclusividade, é o local perfeito para os amantes do tênis, oferecendo um ambiente tranquilo e confortável.'
		},
		{
			question: `Onde comer no ${regionName}?`,
			answer:
				'O Jardim América conta com opções de gastronomia de alto nível, como o restaurante Le Deaux Magots, que oferece um ambiente sofisticado próximo ao Clube Athlético Paulistano, e a Galeria dos Pães, que serve comidas incríveis a qualquer hora do dia. Para um almoço de negócios ou em família, o A Figueira Rubaiyat é uma excelente escolha, oferecendo carnes de qualidade e uma premiada feijoada. O bairro ainda conta com diversos outros locais refinados para refeições e cafés.'
		}
	],
	seo: {
		title: `Quem se interessou por ${regionName} também procurou por`,
		links: [
			{
				title: 'Tipo de imóvel',
				links: [
					{
						label: 'Apartamento',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.APARTMENT],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Casa',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.HOUSE],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Cobertura',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.PENTHOUSE],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					}
				]
			},
			{
				title: ' ',
				links: [
					{
						label: 'Duplex',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.DUPLEX],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Loft',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.LOFT],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Casa de vila',
						route: getCleanStaticListingPath({
							propertyTypes: [PropertyTypeEnum.VILLAGE_HOUSE],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					}
				]
			},
			{
				title: 'Localização',
				links: [
					{
						label: 'Itaim Bibi, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Itaim Bibi']
						})
					},
					{
						label: 'Jardim Paulista, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Jardim Paulista']
						})
					},
					{
						label: 'Vila Nova Conceição, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Vila Nova Conceição']
						})
					}
				]
			},
			{
				title: ' ',
				links: [
					{
						label: 'Higienópolis, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Higienópolis']
						})
					},
					{
						label: 'Brooklin, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Brooklin']
						})
					},
					{
						label: 'Moema, São Paulo',
						route: getCleanStaticListingPath({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Moema']
						})
					}
				]
			}
		],
		discoveryContent: {
			heading: `Mais sobre o ${regionName}`,
			paragraphs: [
				'O Jardim América é um dos bairros mais exclusivos de São Paulo, localizado entre a Avenida Brasil e a Rua Estados Unidos, esse bairro se destaca por sua localização incrível e opções de lazer. Tranquilo, é perfeito para passeios a pé e, à noite, oferece a agitação da Cerqueira César e da Rua Oscar Freire. Nos fins de semana, o Jardim América é ideal para relaxar, com a proximidade dos principais shoppings da cidade, como o Shopping Iguatemi, além da Igreja Nossa Senhora do Brasil, um marco arquitetônico e cultural da região.',
				'O bairro é também lar de renomados restaurantes como o recém inaugurado restaurante francês, Le Deux Magots e A Figueira Rubaiyat, com carnes de alta qualidade e uma das feijoadas mais premiadas de São Paulo. Além disso, conta com clubes de prestígio, como o Clube Athletico Paulistano e a Sociedade Harmonia de Tênis, e suas praças, como a Praça Adolpho Bloch e a Praça General San Martin, oferecem ótimos espaços para relaxamento e lazer ao ar livre. Seus imóveis são notáveis pela arquitetura e design exclusivos, como a casa assinada pelos Irmãos Campana, com paisagismo por Kalil Ferre, e a casa assinada pelos renomados Sig Bergamin e Murilo Lomas, que refletem a sofisticação e o estilo de vida dos moradores do bairro.'
			]
		}
	}
};

export default region;
